import React from "react"
import { useState } from 'react';

import theme from '../../../config/theme';

import { x } from 'react-icons-kit/feather';
import Icon from 'react-icons-kit';
import Button from "../../BaseElements/Button";

const ShowMore = (props) => {
    return (
        <div className="show-more">
            <style jsx>{`
                .show-more {
                    padding: 5px;
                }
            `}</style>
            <Button type="outlined" color="orange" padding={false} height={32} onClick={props.clearFilters}>
                Sterge Filtrele <Icon size={20} icon={x}/>
            </Button>
        </div>
    )
}

export default ShowMore;